module.exports = __webpack_public_path__ + "img/line.5b195eb0.png";